import { useMutation } from "@tanstack/react-query";
import {
  RECURRING_JOBS_EDIT_PATH,
  RECURRING_JOBS_NEW_PATH,
  RECURRING_JOBS_PATH,
} from "../../pages/dashboard/config/routes";
import { api } from "../../utils";
import { useFetch, useToast } from "../hooks";

export const useRecurringJobsFormData = (values, options = {}) =>
  useFetch(`${RECURRING_JOBS_NEW_PATH}`, {
    queryKey: ["recurring_jobs_form_data"],
    params: values,
    refetchOnWindowFocus: false,
    ...options,
  });

export const useGetRecurringJobsJobbers = () =>
  useFetch(`${RECURRING_JOBS_PATH}/favorite_jobbers`, {
    refetchOnWindowFocus: false,
  });

export const useSubmitRecurringJob = () => {
  const toast = useToast();
  return useMutation((values) => api.post(`${RECURRING_JOBS_PATH}`, values), {
    onSuccess: ({ data }) => {
      window.location.href = data.data.recurring_job.url;
    },
    onError: (err) => {
      if (err.response.status === 403) {
        window.location.href = err.response.data?.redirect_url_on_error;
      } else {
        toast.danger(err.response?.data?.error_message);
      }
    },
  });
};

export const useUpdateRecurringJob = (id) => {
  const toast = useToast();
  return useMutation(
    (values) => api.put(`${RECURRING_JOBS_PATH}/${id}`, values),
    {
      onSuccess: ({ data }) => {
        window.location.href = data.data.recurring_job.url;
      },
      onError: (err) => {
        toast.danger(err.response?.data?.error_message);
      },
    }
  );
};

export const useGetRecurringJobs = (jobberId, options = {}) =>
  useFetch(`${RECURRING_JOBS_PATH}`, {
    params: { jobber_id: jobberId },
    refetchOnWindowFocus: false,
    ...options,
  });

export const useGetEditRecurringJobs = (id, options = {}) =>
  useFetch(`${RECURRING_JOBS_EDIT_PATH.replace(":id", id)}`, {
    refetchOnWindowFocus: false,
    ...options,
  });

export const useCancelRecurringJobs = () => {
  const toast = useToast();
  return useMutation(
    (values) => api.put(`${RECURRING_JOBS_PATH}/${values.id}/cancel`, values),
    {
      onSuccess: ({ data }) => {
        window.location.href = data.data.redirect_url;
      },
      onError: (err) => toast.danger(err.response.data.error_message),
    }
  );
};
